import React, { useState } from 'react'
import { useApp } from '../context/AppContext'

export default function InviteModal({ eventName, eventId, onClose }) {
  const { sendInvitation } = useApp()
  const [role, setRole] = useState('co-owner')
  const [copied, setCopied] = useState(false)
  const [email, setEmail] = useState('')
  const [sending, setSending] = useState(false)
  const [sent, setSent] = useState(false)
  const link = `planora.app/join/${eventId}`

  const copyLink = () => {
    navigator.clipboard.writeText(link).catch(() => {})
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  const handleSendInvitation = async () => {
    if (!email) return
    setSending(true)
    try {
      await sendInvitation(eventId, email, role)
      setSent(true)
      setEmail('')
      setTimeout(() => {
        setSent(false)
        onClose()
      }, 1000)
    } catch (error) {
      console.error('Error sending invitation:', error)
      setSending(false)
      alert('Fejl ved sending af invitation')
    }
  }

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <div>
            <div className="modal-title">Inviter til {eventName}</div>
            <div className="modal-subtitle">Del link eller send invitation direkte</div>
          </div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
          <div className="input-group">
            <label className="input-label">Invite-link</label>
            <div className="share-box">
              <span className="share-url">{link}</span>
              <button className="copy-btn" onClick={copyLink}>{copied ? 'kopieret' : 'kopiér'}</button>
            </div>
          </div>

          <div className="input-group">
            <label className="input-label">Rolle</label>
            <div className="perm-row">
              <button className={`perm-btn ${role === 'co-owner' ? 'active' : ''}`} onClick={() => setRole('co-owner')}>med-ansvarlig</button>
              <button className={`perm-btn ${role === 'helper' ? 'active' : ''}`} onClick={() => setRole('helper')}>Medhjælper</button>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '12px 0' }}>
            <div style={{ flex: 1, height: 1, background: '#f0eeff' }} />
            <span style={{ fontSize: 10, color: '#c8c5e0', fontWeight: 500 }}>eller inviter via email</span>
            <div style={{ flex: 1, height: 1, background: '#f0eeff' }} />
          </div>

          <div className="input-group">
            <label className="input-label">Email</label>
            <input className="input" type="email" placeholder="ven@email.dk" value={email} onChange={e => setEmail(e.target.value)} />
          </div>
        </div>

        <div className="modal-footer">
          <button className="modal-cancel" onClick={onClose}>Luk</button>
          <button className="modal-confirm" onClick={handleSendInvitation} disabled={!email || sending || sent}>
            {sent ? 'Sendt!' : sending ? 'Sender...' : 'Send invitation'}
          </button>
        </div>
      </div>
    </div>
  )
}
